import Resumable from 'src/_metronic/_assets/js/components/resumable';
import { decryptGlobal } from 'src/api/helpers/encrypt-decrypt';
import { structureAPI } from 'src/api/modules/structure';
//var CryptoJS = require('crypto-js');

class UpFileResumable {
	constructor() {
		this.r = null;
		this.fileAdd = null;
	}
	subirArchivo() {
		if (this.r) {
			this.r.upload();
		}
	}
	// _desifrarDatos() {
	// 	let user = CryptoJS.AES.decrypt(
	// 		process.env.REACT_APP_FILES_USER,
	// 		process.env.REACT_APP_CLAVE_PRIVADA_DECRIPT
	// 	);

	// 	let pass = CryptoJS.AES.decrypt(
	// 		process.env.REACT_APP_FILES_PASS,
	// 		process.env.REACT_APP_CLAVE_PRIVADA_DECRIPT
	// 	);

	// 	const data = {
	// 		user: user.toString(CryptoJS.enc.Utf8),
	// 		pass: pass.toString(CryptoJS.enc.Utf8),
	// 	};
	// 	return data;
	// }

	_init(ruta) {
		this.r = new Resumable({
			target: process.env.REACT_APP_URL_UPLOAD,
			chunkSize: 1 * 512 * 512,
			simultaneousUploads: 1,
			testChunks: false,
			throttleProgressCallbacks: 0.5,
			query: {
				siteUrl: process.env.REACT_APP_URL_MINOSNET,
				folder: 'Documentos compartidos/' + ruta,
				app: '1',
			},
			generateUniqueIdentifier: function (file) {
				return file.name + '-' + file.size + '-' + Date.now();
			},
			// throttleProgressCallbacks: 1,
		});
	}

	initResumable({
		usuarioConsulta,
		ruta,
		responseError,
		onChange,
		responseSuccess,
		idBTN,
		acceptOnly = [],
		estructureModule = false,
	}) {
		//const dataDesifrada = this._desifrarDatos();
		this._init(ruta);
		// Resumable.js isn't supported, fall back on a different method
		if (!this.r.support) {
		} else {
			let addedFiles = [];
			const element = document.getElementById(idBTN);
			this.r.assignBrowse(element);
			this.r.opts.testChunks = false;
			// Handle file add event
			this.r.on('fileAdded', async function (file) {
				if (estructureModule) {
					const response = await structureAPI.getFileName(file.relativePath);
					const res = JSON.parse(response.nombreArchivo);
					const newName = await decryptGlobal(res.payload, res.iv);
					const renamedFile = new File([file.file], newName, {
						type: file.file.type,
					});
					file.file = renamedFile;
					file.fileName = newName;
					file.name = newName;
					file.relativePath = newName;
					file.uniqueIdentifier = `${newName}-${file.size}-${Date.now()}`;
				}

				if (acceptOnly.length === 0) {
					addedFiles.push(file);
					this.fileAdd = file;
					if (onChange) onChange(file);
				} else {
					if (acceptOnly.includes(file.file.type)) {
						addedFiles.push(file);
						this.fileAdd = file;
						if (onChange) onChange(file);
					} else {
						responseError('Formato de archivo no válido');
					}
				}
			});
			this.r.on('pause', function () {
				// Show resume, hide pause
			});
			this.r.on('complete', function (data) {
				//console.log('complete');
				//responseSuccess(this.fileAdd);
			});
			this.r.on('fileSuccess', function (file, message) {
				//validar que el peso del archivo sea mayor o menor a 200MB
				responseSuccess(addedFiles, message);
				addedFiles = [];
			});
			this.r.on('fileError', function (file, message) {
				// Reflect that the file upload has resulted in error
				//console.log('error', message);
				responseError(message);
			});
			this.r.on('fileProgress', function (file) {
				// Handle progress for both the file and the overall upload
			});
		}
	}
}

export default UpFileResumable;
